/* eslint-disable complexity */
import { QB_OPERATOR_TYPES } from '../helpers/types.js';

const conditionSql = (condition, value) => {
  const {
    EQUAL,
    NOT_EQUAL,
    GREATER_THAN,
    LESS_THAN,
    CONTAINS,
    NOT_CONTAINS,
    BETWEEN,
    GREATER_THAN_OR_EQUAL,
    LESS_THAN_OR_EQUAL,
    START_WITH,
  } = QB_OPERATOR_TYPES;

  if (condition === EQUAL) return `<condition>EQUAL</condition><value>${value}</value>`;
  if (condition === NOT_EQUAL) return `<condition>NOT_EQUAL</condition><value>${value}</value>`;
  if (condition === GREATER_THAN) return `<condition>GREATER_THAN</condition><value>${value}</value>`;
  if (condition === LESS_THAN) return `<condition>LESS_THAN</condition><value>${value}</value>`;
  if (condition === CONTAINS) return `<condition>LIKE</condition><value>${value}</value>`;
  if (condition === NOT_CONTAINS) return `<condition>NOT_LIKE</condition><value>${value}</value>`;
  if (condition === BETWEEN)
    return `<condition>NOT_LIKE</condition><value><from>${value[0]}</from><to>${value[1]}</to></value>`;
  if (condition === GREATER_THAN_OR_EQUAL) return `<condition>GREATER_THAN_OR_EQUAL</condition><value>${value}</value>`;
  if (condition === LESS_THAN_OR_EQUAL) return `<condition>LESS_THAN_OR_EQUAL</condition><value>${value}</value>`;
  if (condition === START_WITH) return `<condition>GREATER_THAN</condition><value>${value}</value>`;
  if (condition === 'NOT_START_WITH') return `<condition>NOT_STARTS_WITH</condition><value>${value}</value>`;

  return condition;
};

const renderFilterSQl = (filter) => {
  const { field, operator, value } = filter.element;

  return `<filter><field>${field}</field>${conditionSql(operator, value) || ''}</filter>`;
};
export const xmlFormat = ({ main, mapGroups, items }) => {
  const groupXML = (item, idGroup) => {
    if (idGroup === main) {
      const groupCondition = mapGroups[idGroup].condition === true ? 'AND' : 'OR';
      return `<group value="${groupCondition}">${filterXML(item, groupCondition)}</group>`; // eslint-disable-line
    }
    const groupCondition = item.element.condition === true ? 'AND' : 'OR';
    return `<group value="${groupCondition}">${filterXML(item.children, groupCondition)}</group>`; // eslint-disable-line
  };
  const filterXML = (filters) => {
    const filterGroup = filters.map((filter) => {
      if (filter.element.type === 'filter') return `${renderFilterSQl(filter) || ''} `;
      return ` ${groupXML(filter)} `;
    });
    return filterGroup.join('');
  };

  const xml = `<xml><query>${groupXML(items, main) || ''}</query></xml>`;

  return xml;
};
